<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Company Deregistration Reasons</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateCompanyDeregistrationReason()">
        <mat-icon>add</mat-icon>
        Add Company Deregistration Reason
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="companyDeregistrationReasons()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCompanyDeregistrationReason($event)"
      (deleteClick)="onDeleteCompanyDeregistrationReason($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
